import { useFrame } from '@react-three/fiber';

// Using a default priority value of 50, this allows the use of any
// number before 50 as a PreRender handler & after 50 as a PostRender Handler

// Doing useFrame((state, delta, xrFrame)=>{}) will use a default priority of 1
// which will execute before ManualRenderLoop calls renderer.render(), this will
// continue the default behavior.

// Doing useFrame((state, delta, xrFrame)=>{}, 51 ) will execute after
// ManualRenderLoop calls renderer.render(), thus creating a PostRender handler.
// Can be useful for post effects or rendering to a custom viewport overlayed on
// the main rendered frame
export default function ManualRenderLoop({
  priority = 50,
  onPreRender = undefined,
  onPostRender = undefined,
}: {
  priority?: number;
  onPreRender?: (dt: number, et: number) => void;
  onPostRender?: (dt: number, et: number) => void;
}) {
  useFrame(({ gl, scene, camera, clock }) => {
    if (onPreRender != null) {
      onPreRender(clock.getDelta(), clock.getElapsedTime());
    }

    gl.render(scene, camera);

    if (onPostRender != null) {
      onPostRender(clock.getDelta(), clock.getElapsedTime());
    }
  }, priority);

  return null;
}
